import { createFileRoute } from '@tanstack/react-router'
import JobDetailsIndex from '@/pages/job-details'

export const Route = createFileRoute('/_authenticated/jobs/$jobId')({
  loader: async ({ params }) => {
    return params.jobId
  },
  component: JobDetailsIndex,
})

export { Route as JobDetailsRoute }
